<template>
    <div :class="layerClassName" :style="layerStyle">
        <div v-for="image in layer.images" class="box_img">
            <a v-if="image.linkUrl" :href="image.linkUrl" target="_blank" class="link_thumb">
                <div class="wrap_img" :style="wrapperStyle">
                    <img :src="image.imageUrl" alt="" :class="imageClassName(image.imageUrl)" @load="onLoad(image.imageUrl, $event)">
                </div>
            </a>
            <div v-else class="wrap_img" :style="wrapperStyle">
                <img :src="image.imageUrl" alt="" :class="imageClassName(image.imageUrl)" @load="onLoad(image.imageUrl, $event)">
            </div>
        </div>
    </div>
</template>

<script>
    const IMAGE_WIDTH_MAP = {
        1: { 1: 1100, 2: 524, 3: 356, 4: 263 },
        2: { 1: 870, 2: 427, 3: 279.33, 4: 205.5 },
        3: { 1: 640, 2: 312, 3: 202.67, 4: 148 }
    };
    
    export default {
        inheritAttrs: false,
        props: ['layer', 'type'],
        data() {
            return {
                imageHeightMap: {}
            };
        },
        computed: {
            layerClassName() {
                return 'item_media item_column' + this.layer.images.length;
            },
            imageClassName() {
                return imageUrl => {
                    if (this.imageHeightMap[imageUrl] > this.calcHeight) {
                        return 'img_center';
                    }
                }
            },
            layerStyle() {
                return `max-height:${this.maxHeight}px`;
            },
            wrapperStyle() {
                return `height: ${this.calcHeight}px`;
            },
            calcHeight() {
                return this.calcWidth * this.layer.ratio;
            },
            calcWidth() {
                return IMAGE_WIDTH_MAP[this.type][this.layer.images.length] || 640; // fallback
            },
            maxHeight() {
                return Math.max(...Object.keys(this.imageHeightMap).map(key => this.imageHeightMap[key]));
            }
        },
        methods: {
            onLoad(imageUrl, { currentTarget }) {
                this.$set(this.imageHeightMap, imageUrl, currentTarget.clientHeight);
            }
        }
    }
</script>
